
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 41 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_512_25)","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M23.917 4.5v6c0 .398.18.78.5 1.06.32.282.755.44 1.208.44h6.833","stroke":"#E2E2E2"}}),_c('path',{attrs:{"d":"M29.042 31.5H11.958c-.906 0-1.775-.316-2.416-.879-.64-.562-1-1.325-1-2.121v-21c0-.796.36-1.559 1-2.121.641-.563 1.51-.879 2.416-.879h11.959l8.541 7.5v16.5c0 .796-.36 1.559-1 2.121-.641.563-1.51.879-2.416.879z","stroke":"#cececea7"}}),_c('g',{attrs:{"clip-path":"url(#clip1_512_25)","stroke":"#F60"}},[_c('path',{attrs:{"d":"M18.895 10.137c.408-1.683 2.802-1.683 3.21 0a1.652 1.652 0 002.466 1.022c1.479-.901 3.172.791 2.271 2.271a1.653 1.653 0 001.02 2.465c1.684.408 1.684 2.802 0 3.21a1.652 1.652 0 00-1.02 2.466c.9 1.479-.792 3.172-2.272 2.271a1.653 1.653 0 00-2.465 1.02c-.408 1.684-2.802 1.684-3.21 0a1.652 1.652 0 00-2.466-1.02c-1.479.9-3.172-.792-2.271-2.272a1.651 1.651 0 00-1.02-2.465c-1.684-.408-1.684-2.802 0-3.21a1.652 1.652 0 001.02-2.466c-.9-1.479.792-3.172 2.272-2.271a1.65 1.65 0 002.465-1.02z"}}),_c('path',{attrs:{"d":"M20.5 20.375a2.875 2.875 0 100-5.75 2.875 2.875 0 000 5.75z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_512_25"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h41v36H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_512_25"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9 6)","d":"M0 0h23v23H0z"}})])])])
          )
        }
      }
    